import { FilterConfig } from 'App/babel/filterConfigs/FilterConfig';
import { FilterPreset, generateFilter } from '../filterGenerators';
import ComparisonTypes from 'Resources/ComparisonTypes';
import AccessType from 'App/enum/AccessType';
import AppService from 'App/legacy/AppService';
import { AppState } from 'App/babel/store/reducers/AppReducer';

const appointmentFilterConfigs = (appState?: AppState): { [key: string]: FilterConfig } => ({
	Date: generateFilter(
		FilterPreset.Date,
		{
			field: 'date',
			title: 'default.date'
		},
		'tasks',
		appState
	),
	RegDate: generateFilter(
		FilterPreset.Date,
		{
			field: 'regDate',
			title: 'default.regDate'
		},
		'past'
	),
	User: generateFilter(
		FilterPreset.User,
		{
			field: 'user.id',
			title: 'default.users'
		},
		AccessType.APPOINTMENT
	),
	Campaign: generateFilter(FilterPreset.Campaign, { field: 'project.id' }),
	Status: {
		title: 'default.status',
		type: 'raw',
		inputType: 'radio',
		displayType: 'radio',
		options: [
			{ text: 'default.all', value: null, inactive: true },
			{ text: 'default.open', value: 'open' },
			{ text: 'default.passed', value: 'closed' }
		],
		build: ({ value }, rb) => {
			if (value === null) {
				return;
			} else if (value === 'closed') {
				rb.addFilter({ field: 'endDate' }, ComparisonTypes.LowerThanEquals, new Date().toISOString());
			} else {
				rb.addFilter({ field: 'endDate' }, ComparisonTypes.GreaterThanEquals, new Date().toISOString());
			}
		}
	},
	Description: generateFilter(FilterPreset.Text, {
		field: 'description',
		title: 'default.description'
	}),
	Notes: generateFilter(FilterPreset.Notes),
	AppointmentType: {
		field: 'activityType.id',
		inputType: 'select',
		multiple: true,
		dataPromise: function (customerId, $q) {
			return $q.when({ data: AppService.getActivityTypes('appointment', true) });
		},
		type: 'list',
		searchField: 'name',
		displayText: 'name',
		multiComparitors: true,
		search: false,
		title: 'default.appointmentTypes',
		listTitle: 'default.appointmentType',
		parent: 'filters.columns.appointment'
	},
	AppointmentOutcome: {
		title: 'default.appointmentOutcome',
		field: 'outcome',
		type: 'list',
		inputType: 'select',
		dataPromise: function (customerId, $q) {
			return $q.when({ data: AppService.getStaticValuesPromise('appointmentOutcome') });
		},
		searchField: 'text',
		displayText: (item: { text: string }) => item.text,
		comparisonType: 'MatchExact',
		parent: 'filters.columns.appointment'
	},
	Id: {
		field: 'id',
		type: 'text',
		title: 'default.id'
	}
});

export default appointmentFilterConfigs;
